module.exports = __webpack_public_path__ + "static/media/inventory-card-icon.ac3d25a1.svg";